import { useRestPostQuery } from 'utils/hooks/api/useRestPostQuery';
import { COPY_CAMPAIGN_URL } from 'api/CampaignIndexAPI';
import { CloneCampaignResponse, CloneCampaignRequest } from 'modules/ai/hooks/campaigns/types';

export const useCloneCampaign = (campaignIdToClone: number) => {
  const { data, refetch, isLoading, isError, isSuccess } = useRestPostQuery<
    CloneCampaignResponse,
    CloneCampaignRequest
  >(COPY_CAMPAIGN_URL, { campaignId: campaignIdToClone }, { enabled: false });

  return { data, refetch, isLoading, isError, isSuccess };
};
